import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./DonorList.css"

export const DonarList = () => {
  return (
        <>
        <RoutingMenu activeScreen="donorList" />
    <div className=''>

        <iframe

            src={`${config.RootUrl}/faculty/library/donorList/donorList.php?isIframe=true`}
            className="iframe col-md-12"
        >
        </iframe>
    </div>
    </>
  )
}
